import * as React       from 'react';
import Box              from '@mui/material/Box';
import Button           from '@mui/material/Button';
import TextField        from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Typography       from '@mui/material/Typography';
import IClass           from 'models/IClass';
import {
    CREATE_CLASS_FORM_NAME,
    EDIT_CLASS_POPUP_SAVE
}                       from 'config/config';
import {
    Controller,
    SubmitHandler,
    useForm
}                       from 'react-hook-form';
import { HttpClient, ApiError } from 'apiclient/ApiClient';

interface IFormInput {
    name:  string;
};

const EditClass = (props: {
    closePopup: ()=>void
    classId: string
    classData: IClass
    invalidate: ()=>void
}) => {
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');
    const client = HttpClient();
    const { control, handleSubmit } = useForm<IFormInput>();
    const onSubmit: SubmitHandler<IFormInput> = async data => {
        setError('');
        setLoading(true);
        try {
            await client.put(`/classes/${props.classId}`, data);
            props.invalidate();
            props.closePopup();
        } catch (err) {
            if (err instanceof ApiError) {
                setError(err.message || 'Failed to update class. Please try again.');
            } else {
                setError('An unexpected error occurred. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };
    return(
        <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
            <Box display='flex' sx={{
                width: '100%',
                flexDirection: 'column',
                gap: 3
            }}>
                <Controller
                    name="name"
                    control={control}
                    defaultValue={props.classData.name}
                    render={({field}) =>
                        <TextField
                            fullWidth
                            label={CREATE_CLASS_FORM_NAME}
                            required
                            {...field}
                        />
                    }
                />
                {error &&
                    <Typography color='error'>{error}</Typography>
                }
                <Button
                    type='submit'
                    variant='contained'
                    fullWidth
                    disabled={loading}
                    sx={{ boxShadow: 'none' }}
                >
                    {EDIT_CLASS_POPUP_SAVE}
                </Button>
                {loading &&
                    <CircularProgress sx={{alignSelf: 'center'}}/>
                }
            </Box>
        </form>
    )
};

export default EditClass;
